module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container_wrap"
  }, [_c('div', {
    staticClass: "container_right_hotrecommend"
  }, [_c('div', {
    staticClass: "container_right_hotrecommend_icon"
  }, [_vm._v("热门推荐")]), _vm._v(" "), _c('div', {
    staticClass: "container_right_hotrecommend_img",
    on: {
      "click": function($event) {
        return _vm.imgClickFun()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgTargeturl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_right_hotrecommend_font"
  }, [_c('ul', [_vm._l((_vm.newsListDataArr), function(item, index) {
    return [_c('li', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'CmsDetail',
          query: {
            id: item.id
          }
        }),
        expression: "{name:'CmsDetail',query:{id:item.id}}"
      }],
      key: index
    }, [_vm._v(_vm._s(item.title))])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "container_right_doublecode"
  }, [_c('img', {
    staticClass: "container_right_doublecode_img",
    attrs: {
      "src": _vm.codedescAndpic.RecommendCode && _vm.codedescAndpic.RecommendCode.length > 0 ? _vm.codedescAndpic.RecommendCode[0].url : '',
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container_right_doublecode_font"
  }, [_c('div', {
    staticClass: "container_right_doublecode_font_up"
  }, [_vm._v("更多精彩内容")]), _vm._v(" "), _c('div', {
    staticClass: "container_right_doublecode_font_down"
  }, [_vm._v("\n          请关注「" + _vm._s(_vm.codedescAndpic ? _vm.codedescAndpic.RecommendCodeDesc : '') + "」\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a68a1396","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/cms/CmsRecommend.vue
// module id = 1308
// module chunks = 0